import { SurveySectionViewModel } from './types';

export const isSurveySectionDone = (item: SurveySectionViewModel) => item.value;
